import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
  Button
} from 'semantic-ui-react';
import Select from 'react-select';
import * as exportClasses from '../export/classes.module.scss';
import * as classes from './classes.module.scss';
import TagEditor from '../../../shared/tag_editor';

const mapValues = (collection) => collection.map(v => ({ value: v.id, label: v.name }));
const mapSelectedValues = (ids, collection) => collection
  .filter(v => ids.indexOf(v.id) > -1)
  .map(v => ({ value: v.id, label: v.name }));

const Attributes = ({
  onDone, updateAttributes, keywordList, colorList, associatedRoomIds, associatedHomeDecorStyleIds
}) => {
  // console.log('attrs');
  //
  const setAtts = useCallback(
    (key) => (values) => updateAttributes({ [key]: values })
  );

  const setKeywords = setAtts('keywordList');
  const setColors = setAtts('colorList');

  const setIds = useCallback(
    (key) => (values) => updateAttributes({ [key]: values.map(v => v.value) })
  );

  const onRoomIds = setIds('associatedRoomIds');
  const onStyleIds = setIds('associatedHomeDecorStyleIds');

  return (
    <div className={ classes.root }>
      <div className={ classes.form }>
        <h5>Colors</h5>
        <TagEditor
          basePath="/stylist/walls/color_tags"
          defaultValue={ colorList.map((v) => ({ value: v, label: v })) }
          onChange={ setColors }
        />
        <h5>Keywords</h5>
        <TagEditor
          basePath="/stylist/walls/keyword_tags"
          defaultValue={ keywordList.map((v) => ({ value: v, label: v })) }
          onChange={ setKeywords }
        />
        <h5>Rooms</h5>
        <Select
          isMulti
          value={ mapSelectedValues(associatedRoomIds, window.rooms) }
          options={ mapValues(window.rooms) }
          onChange={ onRoomIds }
        />
        <h5>Decor Styles</h5>
        <Select
          isMulti
          value={ mapSelectedValues(associatedHomeDecorStyleIds, window.homeDecorStyles) }
          options={ mapValues(window.homeDecorStyles) }
          onChange={ onStyleIds }
        />
      </div>
      <Button
        className={ exportClasses.action }
        onClick={ onDone }
        color="black"
      >
        Done
      </Button>
    </div>
  );
};

Attributes.propTypes = {
  onDone: PropTypes.func.isRequired,
  updateAttributes: PropTypes.func.isRequired,
  keywordList: PropTypes.arrayOf(PropTypes.string).isRequired,
  colorList: PropTypes.arrayOf(PropTypes.string).isRequired,
  associatedRoomIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  associatedHomeDecorStyleIds: PropTypes.arrayOf(PropTypes.number).isRequired
};

export default Attributes;
